import React, { Fragment } from 'react';
import styled from 'styled-components';
import CheckboxWithLabel from '@grnhse/seedling/lib/azalea/components/checkbox_with_label';
import { withLocalePrefix } from 'shared/utils/translation';

type Props = {
  selectedEmailRecipients: Array<string>;
  onChange: any;
};

const t = withLocalePrefix('gdpr.data_collection_rules.view.table.rule');

const options = [
  'candidates_added_manually',
  'prospects_added_manually',
  'agency_submissions',
  'referrals',
];

const RecipientsContainer = styled.div`
  padding-top: 5px;

  :first-of-type: {
    padding-top: 7px;
  }
`;

export default function EmailRecipientsSelector(props: Props) {
  return (
    <Fragment>
      {options.map((option) => (
        <RecipientsContainer key={option}>
          <CheckboxWithLabel
            label={t(`options.${option}`)}
            name={option}
            checked={props.selectedEmailRecipients.includes(option)}
            labelFontWeight="normal"
            onChange={props.onChange}
          />
        </RecipientsContainer>
      ))}
    </Fragment>
  );
}
